import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import architectureInteriorDesignBenefitsImg1 from "../../../assets/architectureInteriorDesignBenefitsImg1.png";
import architectureInteriorDesignBenefitsImg2 from "../../../assets/architectureInteriorDesignBenefitsImg2.png";
import architectureInteriorDesignBenefitsImg3 from "../../../assets/architectureInteriorDesignBenefitsImg3.png";
import architectureInteriorDesignBenefitsImg4 from "../../../assets/architectureInteriorDesignBenefitsImg4.png";
import architectureInteriorDesignBenefitsImg5 from "../../../assets/architectureInteriorDesignBenefitsImg5.png";
import architectureInteriorDesignBenefitsImg6 from "../../../assets/architectureInteriorDesignBenefitsImg6.png";
import architectureInteriorDesignBenefitsImg7 from "../../../assets/architectureInteriorDesignBenefitsImg7.png";
import architectureInteriorDesignBenefitsImg8 from "../../../assets/architectureInteriorDesignBenefitsImg8.png";
import architectureInteriorDesignBenefitsImg9 from "../../../assets/architectureInteriorDesignBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import architectureInteriorDesignFunActivitiesImg1 from "../../../assets/architectureInteriorDesignFunActivitiesImg1.png";
import architectureInteriorDesignFunActivitiesImg2 from "../../../assets/architectureInteriorDesignFunActivitiesImg2.png";
import architectureInteriorDesignFunActivitiesImg3 from "../../../assets/architectureInteriorDesignFunActivitiesImg3.png";
import architectureInteriorDesignFunActivitiesImg4 from "../../../assets/architectureInteriorDesignFunActivitiesImg4.png";
import architectureInteriorDesignFunActivitiesImg5 from "../../../assets/architectureInteriorDesignFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";
import HeadSection from "../../HeadSection.js";

const ArchitectureInteriorDesignPortal = () => {
  const architectureInteriorDesignPage =
    heroContent.architectureInteriorDesignPage;

  const beginnerModules1 = [
    {
      title: "Module 1",
      activities: "11",
      classes: "07",
      description:
        "Basic Design Principles- Learn the fundamentals of design like Balance, Rhythm, Emphasis, Proportion, Movement, Contrast, and Unity using hands-on activities.",
    },
    {
      title: "Module 2",
      activities: "03",
      classes: "02",
      description:
        " Basic Design Laws- Understand design standards and spatial requirements.",
    },
    {
      title: "Module 3",
      activities: "01",
      classes: "01",
      description:
        "Conceptual Design- Explore how to create simple, user-friendly design concepts.",
    },
    {
      title: "Module 4",
      activities: "03",
      classes: "02",
      description:
        " Conceptual Sketching- Practice idea generation through doodles and quick sketches.",
    },
    {
      title: "Module 5",
      activities: "04",
      classes: "02",
      description:
        "Live Sketching- Sketch objects from basic shapes to facial features.",
    },
    {
      title: "Module 6",
      activities: "06",
      classes: "04",
      description:
        "Conceptual Modelling- Build physical models using origami, raw materials, and space modeling techniques.",
    },
  ];

  const beginnerModules2 = [
    {
      title: "Module 1",
      activities: "01",
      classes: "01",
      description:
        " Basic Design Principles - Study the key design elements to create balanced and functional spaces.",
    },
    {
      title: "Module 2",
      activities: "01",
      classes: "01",
      description:
        "Conceptual Design- Learn how to present design ideas clearly.",
    },
    {
      title: "Module 3",
      activities: "01",
      classes: "01",
      description:
        "Conceptual Sketching- Develop early ideas through sketching and visual thinking.",
    },
    {
      title: "Module 4",
      activities: "01",
      classes: "01",
      description:
        " Conceptual Modelling- Create models using various materials to visualize design solutions.",
    },
    {
      title: "Module 5",
      activities: "01",
      classes: "01",
      description:
        " Landscaping- Design green spaces for small urban areas with sustainable solutions.",
    },
    {
      title: "Module 6",
      activities: "01",
      classes: "01",
      description:
        "Building Material Study- Explore different materials and their impact on design and durability.",
    },
    {
      title: "Module 7",
      activities: "01",
      classes: "01",
      description: "AutoCAD 2D- Learn basic drafting techniques in AutoCAD.",
    },
    {
      title: "Module 8",
      activities: "05",
      classes: "04",
      description: "3D Modelling- Start creating 3D designs using SketchUp.",
    },
    {
      title: "Module 9",
      activities: "02",
      classes: "02",
      description:
        " Architectural Photoshop- Design architecture layouts and visuals in Photoshop.",
    },
  ];

  const beginnerModules3 = [
    {
      title: "Module 1",
      activities: "01",
      classes: "01",
      description:
        "Basic Design Principles- Learn and apply essential design principles to space planning.",
    },
    {
      title: "Module 2",
      activities: "01",
      classes: "01",
      description:
        "Conceptual Design- Use AutoCAD to design medium-difficulty house plans.",
    },
    {
      title: "Module 3",
      activities: "01",
      classes: "01",
      description:
        "Conceptual Sketching- Generate and develop ideas through iterative sketching.",
    },
    {
      title: "Module 4",
      activities: "01",
      classes: "01",
      description:
        "Conceptual Modelling- Model design concepts using origami and raw materials.",
    },
    {
      title: "Module 5",
      activities: "01",
      classes: "01",
      description:
        "Landscaping- Plan sustainable outdoor spaces like pocket parks and rooftop gardens.",
    },
    {
      title: "Module 6",
      activities: "01",
      classes: "01",
      description:
        "Building Material Study- Analyze materials for aesthetics and structure.",
    },
    {
      title: "Module 7",
      activities: "05",
      classes: "04",
      description: "AutoCAD 2D- Master 2D drafting skills for architecture.",
    },
    {
      title: "Module 8",
      activities: "07",
      classes: "06",
      description: "3D Modelling- Advance your skills in SketchUp 3D modeling.",
    },
    {
      title: "Module 9",
      activities: "02",
      classes: "02",
      description:
        " Rendering- Visualize designs realistically using Lumion and Enscape.",
    },
    {
      title: "Module 10",
      activities: "02",
      classes: "02",
      description:
        " Architectural Photoshop- Edit and enhance architectural visuals in Photoshop.",
    },
  ];
  const beginnerModules4 = [
    {
      title: "Module 1",
      activities: "04",
      classes: "03",
      description:
        "Basic Design-Principles- Build a strong foundation in design principles through interactive activities.",
    },
    {
      title: "Module 2",
      activities: "09",
      classes: "08",
      description:
        "AutoCAD 2D- Gain in-depth skills in 2D architectural drafting.",
    },
    {
      title: "Module 3",
      activities: "13",
      classes: "12",
      description:
        "3D Modelling- Create complex 3D models using SketchUp and 3ds Max.",
    },
    {
      title: "Module 4",
      activities: "07",
      classes: "06",
      description:
        "Rendering- Produce professional visualizations using Lumion and Enscape.",
    },
    {
      title: "Module 5",
      activities: "07",
      classes: "06",
      description:
        "Architectural Photoshop- Enhance design presentations and visuals using Photoshop.",
    },
  ];

  const benefitsData = [
    {
      title: "Creative Thinking",
      description: "Inspires innovation through hands-on design activities.",
      icon: "Polymath-images/architectureInteriorDesignBenefitsImg1.png",
    },
    {
      title: "Design Fundamentals",
      description:
        "Teaches essential principles of architecture and interior design.",
      icon: "Polymath-images/architectureInteriorDesignBenefitsImg2.png",
    },
    {
      title: "Visual Communication",
      description: "Enhances sketching and digital drawing skills.",
      icon: "Polymath-images/architectureInteriorDesignBenefitsImg3.png",
    },
    {
      title: "3D Modeling Skills",
      description:
        "Introduces industry-standard software like SketchUp and AutoCAD.",
      icon: "Polymath-images/architectureInteriorDesignBenefitsImg4.png",
    },
    {
      title: "TeamWork & Collaboration",
      description: "Encourages peer interaction and group projects.",
      icon: "Polymath-images/architectureInteriorDesignBenefitsImg5.png",
    },
    {
      title: "Cultural Awareness",
      description: "Explores global styles and historical architecture.",
      icon: "Polymath-images/architectureInteriorDesignBenefitsImg6.png",
    },
    {
      title: "Sustainable Design",
      description: "Promotes eco-friendly and responsible design practices.",
      icon: "Polymath-images/architectureInteriorDesignBenefitsImg7.png",
    },
    {
      title: "Presentation Skills",
      description: "Builds confidence in sharing and explaining design ideas.",
      icon: "Polymath-images/architectureInteriorDesignBenefitsImg8.png",
    },
    {
      title: "STEAM Integration",
      description:
        "Combines science, tech, engineering, and math with creativity.",
      icon: "Polymath-images/architectureInteriorDesignBenefitsImg9.png",
    },
  ];
  const activitiesData = [
    {
      title: "Cutting Pasting",
      image: "Polymath-images/architectureInteriorDesignFunActivitiesImg1.png",
    },
    {
      title: "Conceptual Skethching",
      image: "Polymath-images/architectureInteriorDesignFunActivitiesImg2.png",
    },
    {
      title: "String Art",
      image: "Polymath-images/architectureInteriorDesignFunActivitiesImg3.png",
    },
    {
      title: "2D Drafting",
      image: "Polymath-images/architectureInteriorDesignFunActivitiesImg4.png",
    },
    {
      title: "3D Room Interior",
      image: "Polymath-images/architectureInteriorDesignFunActivitiesImg5.png",
    },
  ];

  const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how our Brain Train Abacus Course can enhance your child's cognitive skills, memory, and concentration! Our video walks you through the exciting features of the course, the benefits of learning abacus, and how it can unlock your child's full potential.\n\nClick play and learn how we make learning fun, engaging, and effective for young minds.",
    videoSrc: "https://www.youtube.com/embed/UoabjS2y2U8",
  };

  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
      leftImg={'Polymath-images/astronomyLeft.png'}
      rightImg={'Polymath-images/astronomyRight.png'}
      titlePart1="Architecture & Interior Design"
      // titlePart2="Course"
      description="Polymath-kids offer comprehensive online Architecture & Interior Design course for kids. The online classes' offers two modes -online 1:1 classes and online group classes with trained teachers having years of experience in Architecture & Interior Design."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        title="Beginner Level Course"
        modules={beginnerModules1}
      />
      <CourseTimeline
        title="Beginner Level Course"
        modules={beginnerModules2}
      />
      <CourseTimeline
        title="Beginner Level Course"
        modules={beginnerModules3}
      />
      <CourseTimeline
        title="Beginner Level Course"
        modules={beginnerModules4}
      />
      <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn Civil Engineering"
        subTitle="With 40+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default ArchitectureInteriorDesignPortal;
